import Module from './toastModal'
export default Module
